function notEmpty(item) {
	return !!item;
}

function merge(prev, cur) {
	if (!prev) {
		return '';
	}

	return cur
		? prev + ' ' + cur
		: prev;
}

export default (...classes) => {
	const validClasses = classes.filter(notEmpty);

	if (!validClasses.length) {
		return '';
	}

	return validClasses
		.reduce(merge);
};